import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.keys.js";
import axios, { AxiosResponse } from 'axios';
import { LION_FRONEND_CONFIG_PREFIX } from '@/apis/index';
import Drip from 'drip';
/**
 * 获取 前端 Lion 配置
 * 【 线上线下 liong key 需要保持一致力 】
 * 【 且配置名统一为 maoyan-show-m-web.frontEnd.config.xxx (configKey) 】
 *
 * @param {string} configKey 配置 key 值， 注意不需要带 frontEnd.config. 只需要最后的 key 值即可
 * @returns {(Promise<object | undefined>)} Promise<返回的配置值，如果错误则返回 undefined>
 */
export var getLionConfig = function getLionConfig(configKey) {
  if (typeof configKey !== 'string') throw Error('请填写 lion key');
  var errFn = function errFn() {
    return undefined;
  };
  return axios.get("".concat(LION_FRONEND_CONFIG_PREFIX).concat(configKey), {
    v: +new Date()
  }).then(function (_ref) {
    var code = _ref.code,
      data = _ref.data;
    if (code === 200) {
      try {
        return typeof data === 'string' ? JSON.parse(data) : data;
      } catch (e) {
        errFn();
      }
    }
  }).catch(errFn);
};
export function getLionConfigWithStore(_x) {
  return _getLionConfigWithStore.apply(this, arguments);
}
function _getLionConfigWithStore() {
  _getLionConfigWithStore = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(configKey) {
    var storeOpt,
      storeKey,
      storeValue,
      result,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          storeOpt = _args.length > 1 && _args[1] !== undefined ? _args[1] : {
            expires: '5M',
            forceUpdate: false
          };
          _context.prev = 1;
          storeKey = "lion-store-".concat(configKey);
          if (storeOpt.forceUpdate) {
            _context.next = 9;
            break;
          }
          _context.next = 6;
          return Drip.getStore(storeKey);
        case 6:
          storeValue = _context.sent;
          if (!storeValue) {
            _context.next = 9;
            break;
          }
          return _context.abrupt("return", storeValue);
        case 9:
          _context.next = 11;
          return getLionConfig(configKey);
        case 11:
          result = _context.sent;
          if (result) {
            Drip.setStore(storeKey, result, storeOpt);
          }
          return _context.abrupt("return", result);
        case 16:
          _context.prev = 16;
          _context.t0 = _context["catch"](1);
          console.error('getLionConfigWithStore', _context.t0);
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 16]]);
  }));
  return _getLionConfigWithStore.apply(this, arguments);
}